import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { api } from '@/lib/api';

export default function AdminRewards() {
    const [rewards, setRewards] = useState([]);
    const [redemptions, setRedemptions] = useState([]);

    useEffect(() => {
        api.get('/admin/rewards').then(({ data }) => setRewards(data));
        api.get('/admin/redemptions').then(({ data }) => setRedemptions(data));
    }, []);

    return (
        <AdminLayout>
            <div className="p-10" data-testid="admin-rewards-page">
                <div className="overline">Rewards</div>
                <h1 className="font-serif text-4xl text-navy mt-2 mb-8">Marketplace & Redemptions</h1>

                <div className="overline mb-3">Active Rewards</div>
                <div className="grid md:grid-cols-3 gap-4 mb-12">
                    {rewards.map((r) => (
                        <div key={r.id} className="bg-white border border-border-subtle p-5">
                            <img src={r.image_url} alt="" className="w-full h-32 object-cover mb-3" />
                            <div className="font-serif text-lg text-navy">{r.title}</div>
                            <div className="flex justify-between mt-2 text-xs">
                                <span className="text-gold font-semibold">{r.points_required} pts</span>
                                <span className="text-text-tertiary">{r.quantity_redeemed}/{r.quantity_available} redeemed</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="overline mb-3">Recent Redemptions</div>
                <div className="bg-white border border-border-subtle">
                    <table className="w-full text-sm">
                        <thead className="bg-cream text-text-tertiary text-xs uppercase tracking-widest">
                            <tr><th className="text-left p-4">Customer</th><th className="text-left p-4">Reward</th><th className="text-left p-4">Points</th><th className="text-left p-4">Voucher Code</th><th className="text-left p-4">Valid Until</th></tr>
                        </thead>
                        <tbody>
                            {redemptions.map((r) => (
                                <tr key={r.id} className="border-t border-border-subtle">
                                    <td className="p-4">{r.customer_name}</td>
                                    <td className="p-4">{r.reward_title}</td>
                                    <td className="p-4 font-mono text-rose-700">−{r.points_spent}</td>
                                    <td className="p-4 font-mono">{r.voucher_code}</td>
                                    <td className="p-4 text-xs">{new Date(r.valid_until).toLocaleDateString('en-IN')}</td>
                                </tr>
                            ))}
                            {redemptions.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-text-tertiary">No redemptions yet.</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </AdminLayout>
    );
}
